module.exports = __webpack_public_path__ + "static/img/vaughan1.029e3b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/vaughan1.jpg
// module id = 4
// module chunks = 9